import {useNeoContext} from "@/context/neo/neo.context";
import {FleetService} from "@/service/fleet.service";
import React, {useEffect, useState} from "react";
import GenericWidget from "../widgets/GenericWidget";
import WidgetData from "../widgets/Widget-data";

const ExpenseWidget: React.FC = () => {
  const {filterContext} = useNeoContext();
  const [loginUserId, setLoginUserId] = useState("");

  useEffect(() => {
    if (filterContext?.client?.institutionUserId) {
      setLoginUserId(filterContext.client.institutionUserId);
    }
  }, [filterContext]);

  return (
    <GenericWidget
      title="Expense Types"
      icon="/images/expense_yellow.svg"
      type={4}
      fetchService={FleetService.getfleetdatas}
      addService={FleetService.addfleetdata}
      updateService={FleetService.updatefleetdata}
      deleteService={FleetService.deletefleetdata}
      renderEmptyImage="/images/expenseGroup.svg"
      emptyText="No expense type added yet"
      actionText="Expense Type"
      WidgetContent={WidgetData}
      loginUserId={loginUserId}
      apiresponsekey="otherExpenseTypes"
    />
  );
};

export default ExpenseWidget;
